export default "__VITE_ASSET__BMoEJ0kO__"